module.exports = __webpack_public_path__ + "img/beautiful_mebel.592588bf.png";